var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.talentLoading,
          expression: "talentLoading",
        },
      ],
      staticStyle: { "min-height": "200px" },
    },
    [
      _vm.personData && _vm.personData.length && !_vm.talentLoading
        ? _c(
            "div",
            _vm._l(_vm.personData, function (item, i) {
              return _c(
                "div",
                {
                  key: i,
                  staticClass: "person-item",
                  on: {
                    click: function ($event) {
                      return _vm.goDetails(item.scholarId)
                    },
                  },
                },
                [
                  _c(
                    "el-avatar",
                    {
                      staticStyle: { "min-width": "52px" },
                      attrs: { fit: "cover", size: 52, src: item.avatar },
                      on: { error: _vm.errorHandler },
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: "https://img01.zhitulist.com/avatars/e79129a26c564bc3856ec9b680048103.jpg",
                          alt: "",
                        },
                      }),
                    ]
                  ),
                  _c("div", { staticStyle: { "margin-left": "8px" } }, [
                    _c("div", { staticClass: "person-name" }, [
                      _vm._v(_vm._s(item.scholarVO.scholarName)),
                    ]),
                    _c("div", { staticClass: "item-left ellipsis" }, [
                      _vm._v("所在机构:"),
                      _c(
                        "span",
                        {
                          staticClass: "item-right",
                          attrs: { title: item.scholarVO.scholarOrg },
                        },
                        [_vm._v(_vm._s(item.scholarVO.scholarOrg || "-"))]
                      ),
                    ]),
                    item.scholarVO.fields && item.scholarVO.fields.length
                      ? _c("div", { staticClass: "item-left ellipsis" }, [
                          _vm._v("研究领域:"),
                          _c(
                            "span",
                            {
                              staticClass: "item-right",
                              attrs: {
                                title: item.scholarVO.fields
                                  .map((field) => field.name)
                                  .join(","),
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  item.scholarVO.fields
                                    .map((field) => field.name)
                                    .join(",")
                                )
                              ),
                            ]
                          ),
                        ])
                      : _c("div", { staticClass: "item-left" }, [
                          _vm._v("研究领域:"),
                          _c("span", { staticClass: "item-right" }, [
                            _vm._v("-"),
                          ]),
                        ]),
                    _c("div", { staticClass: "item-left" }, [
                      _vm._v(" 成果数:"),
                      _c(
                        "span",
                        {
                          staticClass: "item-num",
                          staticStyle: { "margin-right": "5px" },
                        },
                        [_vm._v(_vm._s(item.publications_count || 0))]
                      ),
                      _vm._v(" H指数:"),
                      _c(
                        "span",
                        {
                          staticClass: "item-num",
                          staticStyle: { "margin-right": "5px" },
                        },
                        [_vm._v(_vm._s(item.hindex || 0))]
                      ),
                      _vm._v(" 引用数:"),
                      _c("span", { staticClass: "item-num" }, [
                        _vm._v(_vm._s(item.citedby || 0)),
                      ]),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "item-left flex items-center",
                        staticStyle: { "margin-top": "5px" },
                      },
                      [
                        _vm._v("个人主页: "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "pointer flex justify-center items-center",
                            staticStyle: {
                              width: "26px",
                              height: "26px",
                              "border-radius": "50%",
                              "background-color": "#1241C9",
                              "margin-left": "10px",
                            },
                            style: {
                              backgroundColor: item.person_url
                                ? "#1241C9"
                                : "#999999",
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.goInfoUrl(item.person_url)
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                width: "14px",
                                height: "14px",
                                src: require("@/assets/images/talent/boshi.png"),
                                alt: "",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              )
            }),
            0
          )
        : _c("div", [_c("el-empty")], 1),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }